export const DEVICE_STORAGE_KEY = 'ok-soon-ai-device-id';
export const ACCESS_TOKEN_KEY = 'ok-soon-ai-access-token';
export const REFRESH_TOKEN_KEY = 'ok-soon-ai-refresh-token';
export const USER_NAME = 'ok-soon-ai-user-name';
export const USER_THUMBNAIL = 'ok-soon-ai-user-thumbnail';
